import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Images/client/brand/suryanirbhar-wordmark-cropped.png";
import { Container, Arrow } from "./UI";

const pages = [
  ["Home", "/"],
  ["About", "/about"],
  ["Products", "/products"],
  ["Testimonials", "/testimonials"],
];
const media = [
  ["Photo Gallery", "/photo-gallery"],
  ["Video Gallery", "/video-gallery"],
  ["In the News", "/news"],
  ["Events", "/events"],
  ["Product Catalog", "/product-catalog"],
];
export default function HomeNavigation() {
  const pathname = useLocation().pathname.replace(/\/$/, "") || "/";
  const mediaActive = media.some(([, path]) => path === pathname);
  const [open, setOpen] = useState(false);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const header = useRef(null);
  const menuButton = useRef(null);
  const mediaButton = useRef(null);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    const onOutside = (e) => {
      if (header.current && !header.current.contains(e.target)) {
        setOpen(false);
        setMediaOpen(false);
      }
    };
    const onResize = () => {
      if (window.innerWidth >= 1024) setOpen(false);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("pointerdown", onOutside);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("pointerdown", onOutside);
      window.removeEventListener("resize", onResize);
    };
  }, []);
  const close = () => {
    setOpen(false);
    setMediaOpen(false);
  };
  const linkClass =
    "sn-block sn-py-3 sn-text-sm sn-font-medium hover:sn-text-leaf sn-transition";
  return (
    <header
      ref={header}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          if (mediaOpen) {
            setMediaOpen(false);
            mediaButton.current?.focus();
          } else if (open) {
            setOpen(false);
            menuButton.current?.focus();
          }
        }
      }}
      className={`sn-sticky sn-top-0 sn-z-50 sn-border-b sn-transition ${pathname !== "/" || scrolled || open ? "sn-bg-white sn-border-line" : "sn-bg-cream sn-border-transparent"}`}
    >
      <Container className="sn-flex sn-min-h-[88px] sn-items-center sn-justify-between sn-gap-6">
        <Link
          to="/"
          aria-label="Suryanirbhar Agritech home"
          onClick={close}
          className="sn-flex sn-shrink-0 sn-items-center"
        >
          <img
            src={logo}
            alt="Suryanirbhar Agritech - Electrifying Traditional Agriculture"
            width="4969"
            height="1269"
            className="sn-h-14 sn-w-auto sn-max-w-[230px] sn-object-contain sm:sn-h-16 sm:sn-max-w-[285px] lg:sn-h-[70px] lg:sn-max-w-[330px]"
          />
        </Link>
        <button
          ref={menuButton}
          type="button"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          aria-controls="sn-navigation"
          onClick={() => {
            setOpen(!open);
            setMediaOpen(false);
          }}
          className="sn-flex sn-h-11 sn-w-11 sn-items-center sn-justify-center sn-rounded sn-border sn-border-line lg:sn-hidden"
        >
          <svg
            aria-hidden="true"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <path
              d={open ? "M6 6l12 12M18 6L6 18" : "M4 7h16M4 12h16M4 17h16"}
            />
          </svg>
        </button>
        <nav
          id="sn-navigation"
          aria-label="Main navigation"
          className={`${open ? "sn-block" : "sn-hidden"} sn-nav-panel sn-absolute sn-left-0 sn-top-full sn-w-full sn-border-b sn-border-line sn-bg-white sn-px-6 sn-py-4 lg:sn-static lg:sn-block lg:sn-w-auto lg:sn-overflow-visible lg:sn-border-0 lg:sn-bg-transparent lg:sn-p-0`}
        >
          <ul className="sn-flex sn-flex-col lg:sn-flex-row lg:sn-items-center lg:sn-gap-6">
            {pages.map(([name, path]) => (
              <li key={path}>
                <Link
                  to={path}
                  onClick={close}
                  aria-current={path === pathname ? "page" : undefined}
                  className={`${linkClass} ${path === pathname ? "sn-text-leaf" : ""}`}
                >
                  {name}
                </Link>
              </li>
            ))}
            <li
              className="sn-relative"
              onBlur={(e) => {
                if (!e.currentTarget.contains(e.relatedTarget))
                  setMediaOpen(false);
              }}
            >
              <button
                ref={mediaButton}
                type="button"
                onClick={() => setMediaOpen(!mediaOpen)}
                aria-expanded={mediaOpen}
                aria-controls="sn-media-links"
                className={`sn-flex sn-min-h-[44px] sn-w-full sn-items-center sn-gap-2 sn-text-sm sn-font-medium hover:sn-text-leaf ${mediaActive ? "sn-text-leaf" : ""}`}
              >
                Media
                <svg
                  aria-hidden="true"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  stroke="currentColor"
                >
                  <path d={mediaOpen ? "M2 8l4-4 4 4" : "M2 4l4 4 4-4"} />
                </svg>
              </button>
              {mediaOpen && (
                <ul
                  id="sn-media-links"
                  className="sn-border-l sn-border-line sn-pl-4 lg:sn-absolute lg:sn-left-0 lg:sn-top-full lg:sn-w-52 lg:sn-rounded lg:sn-border lg:sn-bg-white lg:sn-p-4"
                >
                  {media.map(([name, path]) => (
                    <li key={path}>
                      <Link
                        to={path}
                        onClick={close}
                        aria-current={path === pathname ? "page" : undefined}
                        className={`${linkClass} ${path === pathname ? "sn-text-leaf" : ""}`}
                      >
                        {name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            <li>
              <Link
                to="/blog"
                onClick={close}
                aria-current={pathname === "/blog" ? "page" : undefined}
                className={`${linkClass} ${pathname === "/blog" ? "sn-text-leaf" : ""}`}
              >
                Newsletter
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                onClick={close}
                aria-current={pathname === "/contact" ? "page" : undefined}
                className={`sn-mt-2 sn-inline-flex sn-min-h-[44px] sn-items-center sn-gap-3 sn-rounded sn-px-5 sn-py-3 sn-text-sm sn-font-medium sn-text-white hover:sn-bg-leaf lg:sn-mt-0 ${pathname === "/contact" ? "sn-bg-leaf" : "sn-bg-forest"}`}
              >
                Contact
                <Arrow className="sn-h-4 sn-w-4" />
              </Link>
            </li>
          </ul>
        </nav>
      </Container>
    </header>
  );
}
